import { useEffect, useMemo, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useNavigate } from 'react-router-dom';
import { AiOutlinePlus } from 'react-icons/ai';
import { toast } from 'react-toastify';
import Skeleton from 'react-loading-skeleton';
import { fetchAllDataAPI } from '../../utils/api';
import ContentWrapper from '../../components/contentwrapper/ContentWrapper';
import { Form, Table } from 'react-bootstrap';
import withAuth from '../../utils/withAuth';

const ClusterHead = () => {
    const [centers, setCenters] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/cluster-head-list');
        getAllCenter();
    }, []);

    const getAllCenter = async () => {
        try {
            setIsLoading(true);
            const res = await fetchAllDataAPI('hr-center-cluster-head-list');

            if (res?.data?.status === 1) {
                setCenters(Array.isArray(res.data.data) ? res.data.data : []);
            } else {
                toast.warning('Check your connection');
            }
        } catch (e) {
            toast.error('Failed to load centers');
        } finally {
            setIsLoading(false);
        }
    };

    // Normalize helpers
    const norm = (v) => (typeof v === 'string' ? v.toLowerCase() : String(v ?? '').toLowerCase());
    const q = norm(searchTerm.trim());

    const filteredCenters = useMemo(() => {
        if (!q) return centers;
        return centers.filter((c) => {
            const name = norm(c?.center_name);
            const mobile = norm(c?.center_mobile || '');
            const id = norm(c?.center_id || '');
            return name.includes(q) || mobile.includes(q) || id.includes(q);
        });
    }, [centers, q]);

    return (
        <div className="companypage">
            <Helmet>
                <title>SATKARTAR:CLUSTER HEAD</title>
            </Helmet>

            <ContentWrapper>
                <div className="card hrpages">
                    <div className="heading p-2 d-flex flex-wrap gap-2 justify-content-between align-items-center">
                        <h5 className="mb-0 text-uppercase" style={{ fontWeight: 500 }}>
                            All Cluster Head ({filteredCenters.length})
                        </h5>

                        <Form.Control
                            style={{ maxWidth: 320 }}
                            type="text"
                            placeholder="Search by Name"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>

                    <div className="table pagetable table-responsive mt-3">
                        <Table responsive="sm" size="sm" striped bordered hover>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    [...Array(6)].map((_, i) => (
                                        <tr key={i}>
                                            <td><Skeleton /></td>
                                            <td><Skeleton /></td>
                                        </tr>
                                    ))
                                ) : filteredCenters.length > 0 ? (
                                    filteredCenters.map((c, idx) => (
                                        <tr key={`${c.center_id}-${idx}`}>
                                            <td>{idx + 1}</td>
                                            <td><Link to={`/center-head-list/${c?.center_id}`}>{c?.center_name || '-'}</Link></td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={2} className="text-center">No Center found.</td>
                                    </tr>
                                )}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                </tr>
                            </tfoot>
                        </Table>
                    </div>
                </div>
            </ContentWrapper>
        </div>
    );
};

export default withAuth(ClusterHead);
